/* eslint-disable no-restricted-syntax */
/* eslint-disable max-lines */
import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Tooltip, OverlayTrigger, Accordion } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";

// import { ReactComponent as ExclamationIcon } from "assets/images/icons/Exclamation.svg";
import { ReactComponent as InfoIcon } from "assets/images/icons/Info.svg";
import CardNew from "components/molecules/Card/CardNew";
import Badge from "components/atoms/Badge/Badge";
import CopyToClipboard from "components/molecules/CopyToClipboard/CopyToClipboard";
import Button from "components/atoms/Button/Button";
import ConversionRate from "components/organisms/ConversionRate/ConversionRate";
import { InvoiceStatusColors } from "constants";
import { formatNumber, formatWeight } from "helpers/commonHelpers";
import { renderAmountPerQuantity } from "helpers/costHelpers";
import { useGetShipmentDetails } from "api/queries/shipments/useGetShipmentDetails";
import { DateTimeFormat } from "helpers/dateTimeHelper";
import { flattenCostItems } from "helpers/invoiceHelper";
import Alert from "components/molecules/Alert/Alert";
import getLabel, { getLabelWithTranslationFallback } from "helpers/getLabel";
import usePermissions from "hooks/usePermissions";
import { useFormatPreferredDatetime } from "hooks/useFormatPreferredDatetime";
import CustomToggle from "./CustomToggle";
import GoodItem from "./GoodItem";
import "./Sheet.scss";

/**
 * Formats a cost value to a string with 2 decimal places and a currency
 * @param {*} value - the cost value
 * @param {*} currency - the cost currency
 * @returns {string} - the formatted cost value
 */
const formatCost = (value, currency = "") => {
  if (value === 0 || value === "0" || !value || value === "0.00") return "-";
  return `${formatNumber(value, 2)} ${currency}`;
};

const Invoice = function ({ invoice, isLoading, totalInvoice }) {
  const { id } = useParams();
  const { permissions } = usePermissions();
  const { formatPreferredDatetime } = useFormatPreferredDatetime(DateTimeFormat.fullDateTimeFormat);
  const { company_shipper_settings } = JSON.parse(permissions);
  const isCustomsBrokerInvoice = invoice?.invoice_type === "customs_broker_invoice" || false;
  const { user_type } = JSON.parse(permissions || "{}");

  const bookingReferenceSetting = company_shipper_settings?.booking_comment_mandatory;
  const location = invoice?.shipment_references?.location_reference;
  const { billed_from, billed_to } = invoice?.billing_info || {};
  const { requested_total_weight, requested_total_weight_uom, actual_total_weight, actual_total_weight_uom } =
    invoice?.good_items || {};
  const {
    total_quoted_amount,
    total_quoted_amount_currency,
    expected_amount_due,
    expected_amount_due_currency,
    quoted_cost_items,
    invoiced_cost_items,
    rate_card_title,
  } = invoice?.financial || {};

  const {
    chargeable_wt: quoted_chargeable_wt,
    chargeable_wt_unit: quoted_chargeable_wt_unit,
    max_wt: quoted_max_wt,
    max_wt_unit: quoted_max_wt_unit,
  } = invoice?.financial?.quoted_service_level?.details || {};
  const {
    chargeable_wt: invoiced_chargeable_wt,
    chargeable_wt_unit: invoiced_chargeable_wt_unit,
    max_wt: invoiced_max_wt,
    max_wt_unit: invoiced_max_wt_unit,
  } = invoice?.financial?.invoiced_service_level?.details || {};

  const quotedChargeableWeight = quoted_chargeable_wt || quoted_max_wt;
  const quotedChargeableUnit = quoted_chargeable_wt_unit || quoted_max_wt_unit;
  const invoicedChargeableWeight = invoiced_chargeable_wt || invoiced_max_wt;
  const invoicedChargeableUnit = invoiced_chargeable_wt_unit || invoiced_max_wt_unit;

  const quotedCostItemCurrencies = flattenCostItems(quoted_cost_items).map((item) => item.currency_origin);
  const invoicedCostItemCurrencies = flattenCostItems(invoiced_cost_items).map((item) => item.currency_origin);

  const { data: shipmentDetail } = useGetShipmentDetails(id, {
    enabled: !!id,
    refetchOnMount: false,
  });

  const [showNonChargeCosts, setShowNonChargeCosts] = useState(false);
  // const [duplicateCostItem, setDuplicateCostItem] = useState([]);

  useEffect(() => {
    if (totalInvoice?.length > 0) {
      // getFinancialInvoicedata();
    }
  }, [invoice]);

  // const getFinancialInvoicedata = () => {
  //   if (totalInvoice?.length > 0) {
  //     const financialInvoiceData = totalInvoice.map((invoice) => ({
  //       invoiced_cost_items: invoice.financial.invoiced_cost_items,
  //     }));
  //     //  combine financial invoice cost item detail
  //     const combinedFinancialInvoice = financialInvoiceData?.reduce(
  //       (result, obj) => result.concat(obj.invoiced_cost_items),
  //       [],
  //     );
  //     //  Get duplicate financial invoice cost item count
  //     const duplicateInvoiceCount = combinedFinancialInvoice.reduce((acc, curr) => {
  //       const { title } = curr;
  //       if (acc[title]) {
  //         acc[title] += 1;
  //       } else {
  //         acc[title] = 1;
  //       }
  //       return acc;
  //     }, {});

  //     const invoiceCountResult = combinedFinancialInvoice.map((obj) => {
  //       obj.count = duplicateInvoiceCount[obj.title];
  //       return obj;
  //     });

  //     // Get duplicate financial invoice cost item detail
  //     const seenObjects = {};
  //     const duplicateObjects = [];

  //     invoiceCountResult?.forEach((obj) => {
  //       if (obj.value !== "" && obj.value !== "0") {
  //         const key = `${obj.title}-${obj.value}`;
  //         if (seenObjects[key]) {
  //           duplicateObjects.push(obj);
  //         } else {
  //           seenObjects[key] = true;
  //         }
  //       }
  //     });
  //     setDuplicateCostItem(duplicateObjects);
  //   }
  // };

  //  Render duplicate cost item detail warning icon
  // const renderDuplicateCostItem = (title, value) => {
  //   if (duplicateCostItem?.length > 0) {
  //     return duplicateCostItem.map((item) => {
  //       if (item.title === title && Number(item.value) === Number(value)) {
  //         return (
  //           <OverlayTrigger
  //             placement="top"
  //             overlay={
  //               <Tooltip id="freight-mode">
  //                 <div className="font-weight-normal">
  //                   <FormattedMessage id="general.sameCostExist" defaultMessage="Same cost item exist in other invoice" />
  //                 </div>
  //                 <div>
  //                   <span className="font-weight-normal">
  //                     <FormattedMessage id="general.totalCost" defaultMessage="Total from all invoice" />:{" "}
  //                   </span>
  //                   <span>
  //                     {Number(value * item?.count).toLocaleString(undefined, {
  //                       minimumFractionDigits: 2,
  //                       maximumFractionDigits: 2,
  //                     })}{" "}
  //                     {item.currency}
  //                   </span>
  //                 </div>
  //               </Tooltip>
  //             }
  //           >
  //             <ExclamationIcon className="mr-3 custom-alert-tertiary-icon" style={{ minWidth: 16 }} />
  //           </OverlayTrigger>
  //         );
  //       }
  //       // Return null for items that don't match the condition
  //       return null;
  //     });
  //   }
  //   //  Return null if duplicateCostItem is empty
  //   return null;
  // };

  /**
   * Renders the percentage difference between quoted and invoiced values
   * @param {*} quotedValue - the quoted cost item value
   * @param {*} invoicedValue - the invoiced cost item value
   * @param {*} quotedCurrency - the quoted cost item currency
   * @param {*} invoicedCurrency - the invoiced cost item currency
   * @param {*} decimalPlaces - the number of decimal places to round to
   * @returns {JSX.Element} - the percentage difference between quoted and invoiced values
   */
  const renderPercentageDifference = (quotedValue, invoicedValue, quotedCurrency, invoicedCurrency, decimalPlaces = 2) => {
    let quotedValueCopy = quotedValue;
    // If currencies are different, convert the quoted currency to invoiced currency
    if (quotedCurrency !== invoicedCurrency) {
      let conversionProperty;
      // The shipment currency is stored in the total_quoted_amount_currency property
      const shipmentCurrency = total_quoted_amount_currency;

      // Determine which conversion rate object to use
      if (quotedCurrency !== expected_amount_due_currency && invoicedCurrency === shipmentCurrency)
        conversionProperty = "shipment_exchange_rates";
      else if (quotedCurrency === expected_amount_due_currency && invoicedCurrency !== shipmentCurrency)
        conversionProperty = "invoice_exchange_rates";
      else return null;

      // Find the conversion rate between the quoted currency and invoiced currency
      const conversionRate = invoice?.conversion_rate_info[conversionProperty]?.find(
        (c) => c.base_currency === invoicedCurrency && c.target_currency === quotedCurrency,
      );
      const conversionRateReverse = invoice?.conversion_rate_info[conversionProperty]?.find(
        (c) => c.base_currency === quotedCurrency && c.target_currency === invoicedCurrency,
      );

      if (conversionRate && conversionRate.rate) quotedValueCopy *= conversionRate.rate;
      else if (conversionRateReverse && conversionRateReverse.rate) quotedValueCopy /= conversionRateReverse.rate;
      else return null;
    }
    const changeInValue = invoicedValue - quotedValueCopy;

    // Define color and prefix based on whether changeInValue is positive or negative
    const color = changeInValue > 0 ? "#EA7939" : "#9EC728";
    const prefix = changeInValue > 0 ? "+" : "";

    // If changeInValue is 0, or either quotedValue or invoicedValue is 0, return null
    if (
      (changeInValue < 0.01 && changeInValue > 0) || // Hide small positive changes
      (changeInValue > -0.01 && changeInValue < 0) || // Hide small negative changes
      changeInValue === 0 ||
      isNaN(quotedValue) ||
      isNaN(invoicedValue) ||
      invoicedValue === 0 ||
      quotedValue === 0
    )
      return null;
    return (
      <span className="ml-2 font-b4" style={{ color }}>
        {prefix}
        {((changeInValue / quotedValueCopy) * 100).toFixed(decimalPlaces)}%
      </span>
    );
  };

  const renderGoodItems = () => {
    const { actual_good_items, requested_good_items } = invoice?.good_items || {};
    // join actual_good_items and requested_good_items if they share the same id
    const combinedGoodItems =
      actual_good_items?.length > 0 &&
      actual_good_items.map((actualItem) => {
        const requestedItem = requested_good_items.find((i) => i.id === actualItem.id || i.id === actualItem.parent_id);
        return { requested: { ...requestedItem }, actual: { ...actualItem } };
      });

    return combinedGoodItems
      ? combinedGoodItems?.map(({ requested, actual }, index) => (
          <GoodItem key={actual.id || index} requested={requested} actual={actual} />
        ))
      : null;
  };

  const combineCostArrays = (quoted_cost_items, invoiced_cost_items) => {
    const combinedArray = [];
    Object.keys(quoted_cost_items ?? {}).forEach((key) => {
      const quotedCosts = quoted_cost_items[key];
      const invoicedCosts = invoiced_cost_items[key];
      const combineCurrentCharge = [];
      quotedCosts.forEach((quotedItem) => {
        const invoicedItem = invoicedCosts.find((invItem) => invItem.original_cost === quotedItem.id);
        if (invoicedItem) {
          combineCurrentCharge.push({
            title: invoicedItem.description || quotedItem.description,
            quotedValue: quotedItem.amount_origin || 0,
            quotedCurrency: quotedItem.currency_origin,
            invoicedValue: invoicedItem.amount_target || 0,
            invoicedCurrency: invoicedItem.target_currency_code,
            measurement_unit_display: quotedItem.measurement_unit_display,
            quantity: quotedItem.quantity,
            quoted_amount_per_unit: quotedItem.amount_per_unit,
            invoiced_amount_per_unit: invoicedItem.amount_per_unit,
            ...(invoicedItem.description &&
              quotedItem.description &&
              invoicedItem.description !== quotedItem.description && {
                subTitle: `Quoted - ${quotedItem.description}`,
              }),
          });
        } else {
          combineCurrentCharge.push({
            title: quotedItem.description,
            quotedValue: quotedItem.amount_origin || 0,
            quotedCurrency: quotedItem.currency_origin,
            invoicedValue: 0,
            invoicedCurrency: invoicedItem?.currency_origin,
            measurement_unit_display: quotedItem.measurement_unit_display,
            quantity: quotedItem.quantity,
            quoted_amount_per_unit: quotedItem.amount_per_unit,
            invoiced_amount_per_unit: invoicedItem?.amount_per_unit,
          });
        }
      });
      for (const invoicedItem of invoicedCosts) {
        const quotedItem = quotedCosts.find((quotedItem) => quotedItem.id === invoicedItem.original_cost);
        if (!quotedItem) {
          combineCurrentCharge.push({
            title: invoicedItem.description,
            quotedValue: 0,
            quotedCurrency: null,
            invoicedValue: invoicedItem.amount_target || 0,
            invoicedCurrency: invoicedItem.target_currency_code,
            measurement_unit_display: invoicedItem.measurement_unit_display,
            quantity: invoicedItem.quantity,
            invoiced_amount_per_unit: invoicedItem.amount_per_unit,
          });
        }
      }
      combinedArray.push({
        group_name: key,
        // Return combinedArray filtered to remove any items that have both a quoted and invoiced value of 0
        items: combineCurrentCharge.filter((item) => Number(item.quotedValue) !== 0 || Number(item.invoicedValue) !== 0),
      });
    });
    return combinedArray;
  };

  const renderCostItems = () => {
    const costItems = combineCostArrays(quoted_cost_items, invoiced_cost_items);
    const nonChargeCosts = costItems.filter((item) => item.invoicedValue === 0 || item.invoicedValue === "0");
    return (
      <div className="font-b3">
        {costItems.length > 0 &&
          costItems.map((group) => (
            <Accordion key={group.group_name}>
              <CustomToggle eventKey={group.group_name} item={group} />
              <Accordion.Collapse eventKey={group.group_name}>
                <div>
                  {group.items
                    ?.filter((item) => item.title !== "Chargeable weight")
                    ?.map((item) => (
                      <Row className="mt-3 mb-3" key={item.title}>
                        <Col className="mb-0">
                          {item.title}
                          {item.subTitle && <div className="text-secondary font-b7 cost-subtitle">{item.subTitle}</div>}
                        </Col>
                        <Col>
                          <p className="m-0">{formatCost(item.quotedValue, item.quotedCurrency)}</p>
                          {Boolean(item.quoted_amount_per_unit) && (
                            <p className="m-0 text-tertiary">
                              {renderAmountPerQuantity({
                                amount_per_unit: item.quoted_amount_per_unit,
                                currency_origin: item.quotedCurrency,
                                measurement_unit_display: item.measurement_unit_display,
                              })}
                            </p>
                          )}
                        </Col>
                        <Col>
                          <div className="d-flex align-items-center">
                            <p className="m-0">{formatCost(item.invoicedValue, item.invoicedCurrency)}</p>
                            {renderPercentageDifference(
                              parseFloat(item.quotedValue),
                              parseFloat(item.invoicedValue),
                              item.quotedCurrency,
                              item.invoicedCurrency,
                            )}
                          </div>
                          {Boolean(item.invoiced_amount_per_unit) && (
                            <p className="m-0 text-tertiary">
                              {renderAmountPerQuantity({
                                amount_per_unit: item.invoiced_amount_per_unit,
                                currency_origin: item.invoicedCurrency,
                                measurement_unit_display: item.measurement_unit_display,
                              })}
                            </p>
                          )}
                        </Col>
                      </Row>
                    ))}
                </div>
              </Accordion.Collapse>
            </Accordion>
          ))}
        {nonChargeCosts.length > 0 && (
          <Button
            variant="link"
            className="pl-0 font-b3"
            label={showNonChargeCosts ? "Hide non-charged costs" : "Show non-charged costs"}
            onClick={() => {
              setShowNonChargeCosts(!showNonChargeCosts);
            }}
          />
        )}
        {nonChargeCosts.length > 0 &&
          showNonChargeCosts &&
          nonChargeCosts.map((item, index) => (
            <Row className="mt-3 mb-3" key={index}>
              <Col>{item.title}</Col>
              <Col>
                {formatNumber(item.quotedValue)} {item.quotedCurrency}
                {item.quotedSubtitle && (
                  <>
                    <br />
                    <span className="text-secondary">{item.quotedSubtitle}</span>
                  </>
                )}
              </Col>
              <Col>-</Col>
            </Row>
          ))}
      </div>
    );
  };
  if (isLoading) return <CardNew isLoading={isLoading} loadingSkeletonRowCount={6} />;
  return (
    <div className="font-b3" style={{ paddingLeft: 9, paddingRight: 9 }}>
      <div className="d-flex align-items-center mb-3">
        <h5>Invoice {invoice.invoice_id}</h5>
        {isCustomsBrokerInvoice && user_type === "shipper" && (
          <Alert noIcon className="ml-xs ml-md" variant="warning">
            <FormattedMessage id="invoices.customBrokerageInvoice" defaultMessage="Customs Brokerage Invoice" />
          </Alert>
        )}
      </div>

      {/* INVOICE DETAILS */}
      <div className="d-flex justify-content-between border-bottom border-grey" style={{ paddingBottom: 16 }}>
        <div className="d-flex flex-column w-50">
          <Row className="mb-1">
            <Col className="text-secondary">
              <FormattedMessage id="billing.invoiceNumber" defaultMessage="Invoice number" />
            </Col>
            <Col lg={7}>{invoice?.invoice_references?.invoice_number}</Col>
          </Row>
          <Row className="mb-1">
            <Col className="text-secondary">
              <FormattedMessage id="billing.invoiceDate" defaultMessage="Invoice date" />
            </Col>
            <Col lg={7}>{formatPreferredDatetime(invoice?.invoice_references?.invoice_submit_datetime)}</Col>
          </Row>
          <Row className="mb-1">
            <Col className="text-secondary">
              <FormattedMessage id="billing.invoiceStatus" defaultMessage="Invoice status" />
            </Col>
            <Col lg={7}>
              <div className="d-flex">
                <Badge label={invoice?.invoice_status} type={InvoiceStatusColors[invoice?.invoice_status] || "secondary"} />
              </div>
            </Col>
          </Row>
          <Row className="mb-1">
            <Col className="text-secondary">
              <FormattedMessage id="billing.shipmentNumber" defaultMessage="Shipment number" />
            </Col>
            <Col lg={7}>{id}</Col>
          </Row>
          <Row className="mb-1">
            <Col className="text-secondary">
              {getLabelWithTranslationFallback("Shipment title", {
                style: "capitalize-first",
                paymentLocation: location,
                translation: <FormattedMessage id="billing.shipmentTitle" defaultMessage="Shipment title" />,
              })}
            </Col>
            <Col lg={7}>{invoice?.shipment_title}</Col>
          </Row>
          {!isCustomsBrokerInvoice && rate_card_title && (
            <Row className="mb-1">
              <Col className="text-secondary">
                <FormattedMessage id="settings.rate-cards.rateCard" defaultMessage="Rate card" />
              </Col>
              <Col lg={7}>{rate_card_title}</Col>
            </Row>
          )}

          {bookingReferenceSetting !== "off" && (
            <Row className="mb-1">
              <Col className="text-secondary">
                {getLabelWithTranslationFallback("Booking reference", {
                  style: "capitalize-first",
                  paymentLocation: location,
                  translation: <FormattedMessage id="billing.bookingReference" defaultMessage="Booking reference" />,
                })}
              </Col>
              <Col lg={7}>{invoice?.booking_reference || "--"}</Col>
            </Row>
          )}

          {invoice?.shipment_references?.custom_field1 && (
            <Row className="mb-1 mt-3">
              <Col className="text-secondary">{getLabel("Custom field 01", "capitalize-first", location)} </Col>
              <Col lg={7}>{invoice?.shipment_references?.custom_field1 || "--"}</Col>
            </Row>
          )}
          {invoice?.shipment_references?.custom_field2 && (
            <Row className="mb-1 mt-3">
              <Col className="text-secondary">{getLabel("Custom field 02", "capitalize-first", location)} </Col>
              <Col lg={7}>{invoice?.shipment_references?.custom_field2 || "--"}</Col>
            </Row>
          )}
          {invoice?.invoice_references?.provider_invoice_ref1 && (
            <Row className="mb-1">
              <Col className="text-secondary">{getLabel("Provider invoice reference 01", "", location)}</Col>
              <Col lg={7}>{invoice.invoice_references.provider_invoice_ref1}</Col>
            </Row>
          )}
          {invoice?.invoice_references?.provider_invoice_ref2 && (
            <Row className="mb-1">
              <Col className="text-secondary">{getLabel("Provider invoice reference 02", "", location)}</Col>
              <Col lg={7}>{invoice.invoice_references.provider_invoice_ref2}</Col>
            </Row>
          )}
          {invoice?.invoice_references?.provider_invoice_ref3 && (
            <Row className="mb-1">
              <Col className="text-secondary">{getLabel("Provider invoice reference 03", "", location)}</Col>
              <Col lg={7}>{invoice.invoice_references.provider_invoice_ref3}</Col>
            </Row>
          )}
          {invoice?.invoice_references?.provider_invoice_ref4 && (
            <Row className="mb-1">
              <Col className="text-secondary">{getLabel("Provider invoice reference 04", "", location)}</Col>
              <Col lg={7}>{invoice.invoice_references.provider_invoice_ref4}</Col>
            </Row>
          )}
          {!!invoice?.tracking_references?.length &&
            invoice.tracking_references.map((trackingReference) => (
              <Row className="mb-1" key={trackingReference?.tracking_type}>
                <Col className="text-secondary">{trackingReference?.tracking_type}</Col>
                <Col lg={7}>{trackingReference?.tracking_number || "--"}</Col>
              </Row>
            ))}
          {invoice?.shipment_references?.cost_center && (
            <Row className="mb-1">
              <Col className="text-secondary">{getLabel("Cost Center / WBS / Project #", "capitalize-first", location)}</Col>
              <Col lg={7}>{invoice.shipment_references.cost_center || "--"}</Col>
            </Row>
          )}
        </div>
        {/* BILLED TO-FROM */}
        <div style={{ width: "30%" }}>
          <div className="mb-3 position-relative">
            <CopyToClipboard
              copyOnly
              text={`${billed_from?.street_address} ${billed_from?.city_name}, ${billed_from?.country_name}`}
            >
              <div className="d-flex justify-content-between font-b9 mb-1">
                <FormattedMessage id="billing.billedFrom" defaultMessage="Billed from" />:
              </div>
              <div>{billed_from?.name}</div>
              <div>{billed_from?.street_address}</div>
              <div>
                {billed_from?.city_name}, {billed_from?.country_name}
              </div>
            </CopyToClipboard>
          </div>
          <div className="mb-3 position-relative">
            <CopyToClipboard
              copyOnly
              text={`${billed_to?.street_address} ${billed_to?.city_name}, ${billed_to?.country_name}`}
            >
              <div className="font-b9 mb-1">
                <FormattedMessage id="billing.billedTo" defaultMessage="Billed to:" />
              </div>
              <div>{billed_to?.name}</div>
              <div>{billed_to?.street_address}</div>
              <div>
                {billed_to?.city_name}, {billed_to?.country_name}
              </div>
            </CopyToClipboard>
          </div>
        </div>
      </div>
      {/* GOODS TABLE */}
      <div>
        <div className="border-bottom border-grey border-1" style={{ paddingBottom: 16, paddingTop: 16 }}>
          <Row className="font-b4 text-secondary">
            <Col>
              <FormattedMessage id="billing.item" defaultMessage="Item" />
            </Col>
            <Col>
              <FormattedMessage id="billing.requestedWeight" defaultMessage="Requested weight" />
            </Col>
            <Col>
              <FormattedMessage id="invoice.invoicedWeight" defaultMessage="Invoiced weight" />
            </Col>
          </Row>
          {renderGoodItems(invoice)}
          <Row style={{ marginTop: 16 }}>
            <Col>
              <h6>
                <FormattedMessage id="general.total" defaultMessage="Total" />
              </h6>
            </Col>
            <Col>
              <h6>
                {formatNumber(requested_total_weight)} {requested_total_weight_uom}
              </h6>
            </Col>
            <Col>
              <h6>
                {formatNumber(actual_total_weight)} {actual_total_weight_uom}
              </h6>
            </Col>
          </Row>
          {invoicedChargeableWeight && (
            <Row className="mt-4 font-b3">
              <Col>
                <FormattedMessage id="quotation-form.chargeableWeight" defaultMessage="Chargeable weight" />
              </Col>
              <Col>{formatWeight(quotedChargeableWeight, quotedChargeableUnit)}</Col>
              <Col>{formatWeight(invoicedChargeableWeight, invoicedChargeableUnit)}</Col>
            </Row>
          )}
        </div>
        {/* COSTS TABLE */}
        <div style={{ paddingBottom: 16, paddingTop: 16 }}>
          <Row className="font-b4 text-secondary">
            <Col>
              <FormattedMessage id="billing.item" defaultMessage="Item" />
            </Col>
            <Col>
              <FormattedMessage id="invoice.quotedCost" defaultMessage="Quoted cost" />
            </Col>
            <Col>
              <FormattedMessage id="invoice.invoicedCost" defaultMessage="Invoiced cost" />
            </Col>
          </Row>
          {renderCostItems(invoice)}
          <Row style={{ marginTop: 16 }}>
            <Col>
              <h6>
                <FormattedMessage id="general.total" defaultMessage="Total" />
              </h6>
            </Col>
            <Col>
              {!isCustomsBrokerInvoice && (
                <h6>
                  {formatNumber(total_quoted_amount, 2)} {total_quoted_amount_currency}
                </h6>
              )}
            </Col>
            <Col>
              <div className="d-flex align-items-center">
                <h6>
                  {formatNumber(expected_amount_due, 2)} {expected_amount_due_currency}{" "}
                </h6>
                {renderPercentageDifference(
                  total_quoted_amount,
                  expected_amount_due,
                  total_quoted_amount_currency,
                  expected_amount_due_currency,
                  1,
                )}
              </div>
            </Col>
          </Row>
          <Row>
            <Col />
            <Col>
              {invoice?.conversion_rate_info?.shipment_exchange_rates
                .filter(
                  (item) =>
                    item.base_currency !== item.target_currency && quotedCostItemCurrencies.includes(item.target_currency),
                )
                .map((item, index) => (
                  <Fragment key={index}>
                    <ConversionRate item={item} _class="mt-sm" />
                  </Fragment>
                ))}
            </Col>
            <Col>
              {invoice?.conversion_rate_info?.invoice_exchange_rates
                .filter(
                  (item) =>
                    item.base_currency !== item.target_currency && invoicedCostItemCurrencies.includes(item.target_currency),
                )
                .map((item, index) => (
                  <Fragment key={index}>
                    <ConversionRate item={item} _class="mt-sm" />
                  </Fragment>
                ))}
            </Col>
          </Row>
        </div>
      </div>
      <div>
        <div>
          {!isCustomsBrokerInvoice && (
            <div className="font-b4 mt-3">
              <span>
                <FormattedMessage id="billing.totalShipmentCharges" defaultMessage="Total shipment charges" />
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip>
                      <span className="font-weight-normal">
                        <FormattedMessage
                          id="billing.totalShipmentChargesTooltip"
                          defaultMessage="Total of this invoice and previously submitted invoices"
                        />
                      </span>
                    </Tooltip>
                  }
                >
                  <InfoIcon className="ml-2" />
                </OverlayTrigger>
              </span>
              <span style={{ marginLeft: 90 }}>{`${formatNumber(
                shipmentDetail?.financial?.invoices?.total_invoiced_amount,
                2,
              )} ${shipmentDetail?.financial?.invoices?.total_invoiced_amount_currency}`}</span>
            </div>
          )}
          {invoice?.comments && (
            <>
              <div className="mt-3xl mb-sm font-b4">
                <FormattedMessage id="invoices.remarks" defaultMessage="Remarks" />
              </div>
              <div>{invoice?.comments}</div>
            </>
          )}
        </div>
      </div>
      <div className="text-secondary mt-4 border-top border-grey font-b3" style={{ paddingTop: 16 }}>
        <FormattedMessage
          id="components.molecules.sheet.summaryGeneratedBy"
          defaultMessage="Shipment Summary Generated on Cargobase"
        />
      </div>
    </div>
  );
};

Invoice.propTypes = {
  invoice: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
  totalInvoice: PropTypes.instanceOf(Object).isRequired,
};
export default Invoice;
